<template>
    <div class="data-screen column height-100p" @click="triggerFullScreen">
        <div class="row height-75 top">
            <div class="top-left row align-items-center">
                <img class="margin-left-20 margin-right-10" src="./images/logo.svg" alt="">
                <span class="support">森果技术支持</span>
                <span class="font-size-24 color-fff">-农鼎慧</span>
            </div>
            <div class="top-center">
                <h1>{{chain_shop.name}}</h1>
            </div>
            <div class="top-right row justify-content-flex-end align-items-center">
                <span>{{dayJs(currentTime).format('YYYY-MM-DD')}}</span>
                <span class="margin-left-20 margin-right-30">{{dayJs(currentTime).format('HH:mm:ss')}}</span>
            </div>
        </div>
        <div class="expaned content row padding-top-30 overflow-hidden">
            <div class="left column">
                <!-- <div class="video-container flex-shrink">

                </div> -->
                <div class="row space-between">
                    <div class="goods-data width-210 height-120">
                        <div class="title row align-items-center"><i></i>上架商品数</div>
                        <div class="amout">{{goods_count}}</div>
                    </div>
                    <div class="stock-data width-210 height-120">
                        <div class="title row align-items-center"><i></i>库存总量</div>
                        <div class="amout">{{goods_stock_sum}}</div>
                    </div>
                </div>
                <h2 class="margin-top-30 margin-bottom-24">商品均价</h2>
                <div class="expaned padding-bottom-30 overflow-hidden hidden-scrollbar" id="scrollDom" v-autoScroll>
                    <div class="goods-item row align-items-center space-between" v-for="(item, index) in goodsList" :key="index">
                        <div class="row align-items-center expaned overflow-hidden">
                            <img :src="item.img ? getQiniuImgUrl(item.img) : noGoodsImg" alt="">
                            <div class="column margin-left-20 justify-content-center overflow-hidden">
                                <span class="goods-name">{{item.name}}</span>
                                <span class="date">{{dayJs(item.update_time).format('YYYY-MM-DD')}}</span>
                            </div>
                        </div>
                        <div class="price margin-right-30 white-space-nowrap">
                            <span>{{item.avg_price}}</span>/<span>{{item.unit_name}}</span>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 中间部分 -->
            <div class="column space-between center-box expaned padding-h-30">
                <!-- 交易额板块 -->
                <div class="row order-content">
                    <!-- 今日交易额 -->
                    <div class="total expaned">
                        <!-- 装饰器 -->
                        <div class="a1"></div>
                        <div class="money-1"></div>
                        <div class="decorator"></div>
                        <div class="rotate"></div>
                        <div class="content">
                            <p class="title"><i></i>今日交易金额</p>
                            <p class="moeny">{{ todayTotalmoenyTween }}</p>
                            <p class="yesterday">
                                <span>昨日交易金额：</span>
                                <span>{{yesterdayTotalmoeny}}</span>
                            </p>
                        </div>
                    </div>
                    <!-- 今日订单数 -->
                    <div class="order expaned margin-left-32">
                        <!-- 装饰器 -->
                        <div class="a1"></div>
                        <div class="order-1"></div>
                        <div class="decorator"></div>
                        <div class="rotate"></div>
                        <div class="content">
                            <p class="title"><i></i>今日订单数</p>
                            <p class="moeny">{{ todayOrderNumberTween }}</p>
                            <p class="yesterday">
                                <span>昨日总订单数：</span>
                                <span>{{yesterdayOrderNumber}}</span>
                            </p>
                        </div>
                    </div>
                </div>

                <!-- 分时销售额板块 -->
                <div class="tiem-share-content">
                    <!-- 装饰器 -->
                    <div class="decorator"></div>
                    <div class="title row space-between align-items-center">
                        <div class="row space-between align-items-center">
                            <i class="v-line"></i><span>分时销售额</span>
                            <i class="h-line-1 margin-right-5 margin-left-20"></i><span>今日曲线</span>
                            <i class="h-line-2 margin-right-5 margin-left-10"></i><span>昨日曲线</span>
                        </div>
                        <span>单位（元）</span>
                    </div>
                    <div id="timeDateCharts" style="width: 100%; height: 100%"></div>
                </div>

                <!-- 近七日的销售额 -->
                <div class="recent-content" id="sevenday">
                     <!-- 装饰器 -->
                    <div class="decorator"></div>
                    <div class="title row space-between align-items-center">
                        <div class="row space-between align-items-center">
                            <i class="v-line"></i><span>近七日销售总额</span>
                        </div>
                        <span>单位（万元）</span>
                    </div>
                    <div id="sevenDayData" style="width: 100%; height: 100%"></div>
                </div>
            </div>
            <div class="right column">
                <!-- <div class="video-container flex-shrink">

                </div> -->
                <div class="expaned shop-list column overflow-hidden">
                    <!-- 装饰器 -->
                    <div class="decorator"></div>
                    <div class="shop-count-bg"></div>

                    <!--  -->
                    <div class="top">
                        <p class="title"><i></i>商户数</p>
                        <p class="count">{{shop_count}}</p>
                        <p><i></i>商户今日交易笔数</p>
                    </div>
                    <div class="center-1 expaned overflow-hidden" v-autoScroll>
                        <div class="item" v-for="(shop, index) in shopList" :key="index">
                            <div class="col-1">
                                <img :src="getGradeIcon(index + 1)" alt="" v-if="index < 3">
                                <span v-else>{{ index + 1 < 10 ? '0' + index + 1 : index + 1}}</span>
                            </div>
                            <div class="col-2">{{shop.shop_name}}</div>
                            <div class="col-3">
                                <div class="grid-wrap">
                                    <div class="grid-item" :class="index+ 1 === 1 ? 'first' : 'other'">
                                        <div v-for="(item, index) in shopList[0].order_count > 0 ? (Math.floor(shop.order_count / shopList[0].order_count * 10)) : 0" :key="index"></div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-4" :class="index+1 === 1 ? 'first' : 'other'">{{shop.order_count}}</div>
                        </div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import c1 from './images/c1.svg'
import c2 from './images/c2.svg'
import c3 from './images/c3.svg'
import echarts from 'echarts'
import $fetch from '@/api'
import TWEEN from '@tweenjs/tween.js'
import dayjs from 'dayjs'
import { openMessage } from '@/utils/system'
import { qiniuImageURLPrefix, getQiniuImgUrl } from '@/assets/ts/qiniu'
import { setObjectItemToFixed } from '@/utils/index'
import noGoodsImg from './images/no-goods-img.png'

function autoScroll(el) {
    clearInterval(el.scrollTimer)
    if (el.scrollHeight > el.clientHeight) {
        const oldClone = el.getElementsByClassName('clone')
        if (oldClone.length > 0 && el.contains(oldClone[0])) {
            el.removeChild(oldClone[0])
        }
        const cloneDiv = document.createElement('div')
        cloneDiv.className = "clone"
        Array.from(el.children).forEach(el => cloneDiv.appendChild(el.cloneNode(true)))
        el.appendChild(cloneDiv)
        el.scrollTimer = setInterval(() => {
            if (Math.floor(el.scrollTop) === Math.floor(el.scrollHeight / 2)) {
                el.scrollTop = 16
            } else if (el.scrollHeight > el.scrollTop + el.clientHeight) {
                el.scrollTop = el.scrollTop + 1
            }
        }, 16);
    }
}

export default {
    data() {
        return {
            chain_shop: {},
            todayTotalmoeny: 0,  // 今日交易额
            todayTotalmoenyTween: 0,
            todayOrderNumber: 0, // 今日订单数
            todayOrderNumberTween: 0,
            yesterdayTotalmoeny: 0, // 昨日交易额
            yesterdayOrderNumber: 0, // 昨日订单数
            goods_count: 0, // 上架商品数
            goods_stock_sum: 0, // 库存总量
            goodsList: [],
            shop_count: 0,
            shopList: [],
            currentTime: new Date()
        }
    },

    watch: {
        todayTotalmoeny (newValue, oldValue) {
            // this.initTween(newValue, oldValue, (val) => {
                this.todayTotalmoenyTween = newValue
            // })
            // new TWEEN.Tween({
            //     number: oldValue
            // }).to({
            //     number: newValue
            // }, 1000).onUpdate(tween => {
            //     this.todayTotalmoenyTween = tween.number.toFixed(2)
            // }).start()

            // function animate() {
            //     if (TWEEN.update()) {
            //         requestAnimationFrame(animate);
            //     }
            // }
            // animate()
        },
        todayOrderNumber(newValue, oldValue) {
            // this.initTween(newValue, oldValue, (val) => {
                this.todayOrderNumberTween = newValue
            // })
            // new TWEEN.Tween({
            //     number: oldValue
            // }).to({
            //     number: newValue
            // }, 1000).onUpdate(tween => {
            //     this.todayOrderNumberTween = tween.number.toFixed(2)
            // }).start()

            // function animate() {
            //     if (TWEEN.update()) {
            //         requestAnimationFrame(animate);
            //     }
            // }
            // animate()
        }
    },

    created() {
        this.qiniuImageURLPrefix = qiniuImageURLPrefix
        this.noGoodsImg = noGoodsImg
        this.shopId = this.$route.query.shopId
        this.getShopInfo()
        // console.log(this.$route)
        this.timeInterval = setInterval(() => {
            this.currentTime = new Date()
        }, 1000);
    },

    mounted() {
        this.initCharts()
        this.initData()
        this.pollingChartsDataTimer = setInterval(() => {
            this.initChartsData()
        }, 60 * 1000);

        this.pollintDataTimer = setInterval(() => {
            this.initNormalData()
        }, 5 * 1000)

        setTimeout(() => {
            document.getElementById('senguo-feedback-a5j6f9k2').remove()
        }, 10000)
        document.documentElement.webkitRequestFullScreen()
        window.addEventListener("resize", this.resizeCharts)
    },

    beforeDestroy() {
        clearInterval(this.pollingChartsDataTimer)
        clearInterval(this.timeInterval)
        clearInterval(this.pollintDataTimer)

        window.removeEventListener('resize', this.resizeCharts)
    },

    directives: {
        autoScroll: {
            inserted: function(el) {
                autoScroll(el)
            },

            componentUpdated: function(el) {
                autoScroll(el)
            },

            unbind: function(el) {
                clearInterval(el.scrollTimer)
            }
        }
    },

    methods: {
        dayJs: dayjs,
        // initTween(newValue, oldValue, callback) {
        //     return new TWEEN.Tween({
        //         number: oldValue
        //     }).to({
        //         number: newValue
        //     }, 1000).onUpdate(tween => {
        //         // this.todayTotalmoenyTween = tween.number.toFixed(2)
        //         callback(tween.number.toFixed(2))
        //         return tween.number.toFixed(2)
        //     }).start()

        //     function animate() {
        //         if (TWEEN.update()) {
        //             requestAnimationFrame(animate);
        //         }
        //     }
        //     animate()
        // },

        resizeCharts() {
            this.timeDataCharts.resize()
            this.sevenDayCharts.resize()
        },

        triggerFullScreen() {
            if (this.isFullScreen()) {
                this.exitFullscreen()
            } else {
                this.full(document.documentElement)
            }
        },

        full(ele) {
            if (ele.requestFullscreen) {
                ele.requestFullscreen();
            } else if (ele.mozRequestFullScreen) {
                ele.mozRequestFullScreen();
            } else if (ele.webkitRequestFullscreen) {
                ele.webkitRequestFullscreen();
            } else if (ele.msRequestFullscreen) {
                ele.msRequestFullscreen();
            }
        },

        exitFullscreen() {
            if(document.exitFullScreen) {
                document.exitFullScreen();
            } else if(document.mozCancelFullScreen) {
                document.mozCancelFullScreen();
            } else if(document.webkitExitFullscreen) {
                document.webkitExitFullscreen();
            } else if(document.msExitFullscreen) {
                document.msExitFullscreen();
            }
        },

        isFullScreen() {
            return  !! (
                document.fullscreen || 
                document.mozFullScreen ||                         
                document.webkitIsFullScreen ||       
                document.webkitFullScreen || 
                document.msFullScreen 
            );
        },

        initData() {
            this.initNormalData()
            this.initChartsData()
        },

        initNormalData() {
            Promise.all([this.gettradingdatabriefsToday(), this.gettradingdatabriefsYesterday()]).then( res => {
                this.todayTotalmoeny = res[0].order_subtotal_sum
                this.todayOrderNumber = res[0].order_count_sum
                this.yesterdayTotalmoeny = res[1].order_subtotal_sum
                this.yesterdayOrderNumber = res[1].order_count_sum
            })

            
            this.getbranchdata()
            // this.getTradingDataBriefs()
            this.getbranchShopTradingData()
        },

        initChartsData() {
            this.getSevenDayData()

            Promise.all([this.getdaypartingdatabriefs(new Date()), this.getdaypartingdatabriefs(dayjs().subtract(1, 'day').toDate())])
                .then(([today, yesterday]) => {
                    // console.log(today, yesterday)
                    const workTimes = [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21]
                    let hours = []
                    const nowHour = dayjs().hour()
                    const hourIndex = workTimes.findIndex(h => h === nowHour)
                    if (hourIndex !== -1) { // 白天上班时间
                        // 以下代码为取出 8 小时的时间段
                        let index = 0
                        while (index < workTimes.length - 7) {
                            hours = []
                            for (let j = 0; j < 8; j++) {
                                hours.push(workTimes[index + j])
                            }
                            const nowIndex = hours.findIndex(val => val === nowHour)
                            if (nowIndex === 4) {
                                break
                            } else if (nowIndex !== -1 && nowIndex < 4) {
                                break
                            }
                            index++
                        }
                    } else { // 晚上下班时间
                        hours = workTimes.slice(0, 8)
                    }
                    // console.log(yesterday,  today)
                    this.genarateTimeDataCharts({
                        times: hours.map(hour => `${hour}:00-${hour + 1}:00`),
                        yesterday: hours.map(h => {
                            const data = yesterday.find(val => val.hour === h)
                            return +data.sales_income + +data.online_sales_income
                        }),
                        today: hours.filter(val => val < nowHour).map(h => {
                            const data = today.find(val => val.hour === h)
                            return +data.sales_income + +data.online_sales_income
                        })
                    })
                })
        },

        getGradeIcon(type) {
            switch(type) {
                case 1 :
                    return c1
                case 2 :
                    return c2
                case 3 :
                    return c3
            }
        },

        initCharts() {
            this.timeDataCharts = echarts.init(document.getElementById('timeDateCharts'));
            this.genarateTimeDataCharts({
                times: [5, 6, 7, 8, 9, 10, 11, 12].map(hour => `${hour}:00-${hour + 1}:00`),
                yesterday: [],
                today: []
            })
            this.sevenDayCharts = echarts.init(document.getElementById('sevenDayData'));
            this.genarate7DaysData([])
        },

        genarateTimeDataCharts(data) {
            console.log(data)
            
            const options = {
                grid: {
                    left: '3%',
                    right: '4%',
                    bottom: '3%',
                    containLabel: true
                },
                xAxis: {
                    type: 'category',
                    // boundaryGap: false,
                    data: data.times,
                    axisLine: {
                        // show: false,
                        // color: '#ff'
                        lineStyle: {
                            color: '#4A4D56'
                        }
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        fontSize: 15,
                        color: '#D4D4D4',
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#fff'
                    },
                    splitLine: {
                        // show: false
                        lineStyle: {
                            type: 'dashed',
                            color: '#4A4D56',
                            opacity: 0.5,
                        }
                    },
                    axisLabel: {
                        fontSize: 15,
                        color: '#fff',
                        fontWeight: 600
                    },
                    max: function (value) {
                        return value.max + 40;
                    }
                },
                series: [
                    {
                        type: 'line',
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 0,
                                colorStops: [{
                                    offset: 0, color: 'rgba(20,204,155,0.39) ' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(249,236,30,0.00)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        },
                        lineStyle: {
                            color: 'rgb(23, 136, 103, 0.3)'  
                        },
                        itemStyle: {
                            opacity: 0  
                        },
                        data: data.yesterday,
                        
                    },
                    {
                        type: 'line',
                        areaStyle: {
                            color: {
                                type: 'linear',
                                x: 0,
                                y: 0,
                                x2: 1,
                                y2: 0,
                                colorStops: [{
                                    offset: 0, color: 'rgba(20,204,155,0.39) ' // 0% 处的颜色
                                }, {
                                    offset: 1, color: 'rgba(249,236,30,0.00)' // 100% 处的颜色
                                }],
                                global: false // 缺省为 false
                            }
                        },
                        lineStyle: {
                            color: '#07FFBD'
                        },
                        itemStyle: {
                            color: '#fff',
                        },
                        data: data.today,
                        label: {
                            show: true,
                            color: '#07FFBD',
                            fontFamily: 'dataScreenNumber'
                        }
                    }
                ]
            }

            this.timeDataCharts.setOption(options)
        },

        genarate7DaysData(data) {
            var chart = echarts.init(document.getElementById('sevenDayData'));
            const dateTime = new Array(7).fill(1).map((val, index) => {
                const date = dayjs().subtract(7 - index, 'day')
                return `${date.month() + 1}月${date.date()}日`
            })
            
            const options = {
                grid: {
                    left: 60,
                    top: 70,
                    bottom: 40,
                    right: 30
                },
                xAxis: {
                    type: 'category',
                    data: dateTime,
                    axisLine: {
                        // show: false,
                        // color: '#ff'
                        lineStyle: {
                            color: '#4A4D56'
                        }
                    },
                    axisTick: {
                        show: false,
                    },
                    axisLabel: {
                        fontSize: 15,
                        color: '#D4D4D4',
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        color: '#fff'
                    },
                    splitLine: {
                        // show: false
                        lineStyle: {
                            type: 'dashed',
                            color: '#4A4D56',
                            opacity: 0.5,
                        }
                    },
                    axisLabel: {
                        fontSize: 15,
                        color: '#fff',
                        fontWeight: 600,
                    },
                    max: function (value) {
                        return value.max + 40;
                    }
                },
                series: [{
                    data: data,
                    type: 'bar',
                    barMaxWidth: 61,
                    itemStyle: {
                        color: new echarts.graphic.LinearGradient(
                            0, 0, 0, 1,       //4个参数用于配置渐变色的起止位置, 这4个参数依次对应右/下/左/上四个方位. 而0 0 0 1则代表渐变色从正上方开始
                            [
                                {offset: 0, color: '#14CC9B'},
                                // {offset: 0.5, color: '#888'},
                                {offset: 1, color: '#F9EC1E'}
                            ]                //数组, 用于配置颜色的渐变过程. 每一项为一个对象, 包含offset和color两个参数. offset的范围是0 ~ 1, 用于表示位置
                        ),
                        barBorderRadius: [12, 12, 0, 0]
                    },
                    label: {
                        show: true,
                        position: 'top',
                        fontSize: 20,
                        color: '#14cc9b',
                        fontWeight: 600,
                        fontFamily: 'dataScreenNumber'
                    }
                }]
            }

            this.sevenDayCharts.setOption(options)
        },
    
        gettradingdatabriefsToday() {
           return $fetch.post({
                url: '/chain/gettradingdatabriefs',
                params: {
                    chain_shop_uid: this.shopId // '74b42db82ef74da5ae78ac1bd15efe20',
                }
            }).then(data => {
                return data
            })
        },

        gettradingdatabriefsYesterday() {
            return $fetch.post({
                url: '/chain/gettradingdatabriefs',
                params: {
                    chain_shop_uid: this.shopId, // '74b42db82ef74da5ae78ac1bd15efe20',
                    date_at: dayjs(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
                }
            }).then(data => {
                return data
            })
        },

        getSevenDayData() {
            $fetch.post({
                url: '/chain/getlastsevendaysdata',
                params: {
                    chain_shop_uid: this.shopId //'74b42db82ef74da5ae78ac1bd15efe20'
                }
            }).then(data => {
                this.genarate7DaysData(data.map(val => +(val.order_subtotal_sum / 10000).toFixed(2)))
            }).catch(e => {
                openMessage("error", e.message)
            })
        },

        getdaypartingdatabriefs(date = new Date()) {
            return $fetch.post({
                url: '/chain/getdaypartingdatabriefs',
                params: {
                    chain_shop_uid: this.shopId, // '74b42db82ef74da5ae78ac1bd15efe20',
                    specify_date: dayjs(date).format('YYYY-MM-DD')
                }
            }).then(data => {
                return setObjectItemToFixed(data)
                // this.genarate7DaysData(data.map(val => val.order_subtotal_sum))
            }).catch(e => {
                openMessage("error", e.message)
            })
        },

        getbranchdata() {
            $fetch.post({
                url: '/chain/getbranchdata',
                params: {
                    chain_shop_uid: this.shopId, // '74b42db82ef74da5ae78ac1bd15efe20'
                }
            }).then(data => {
                // this.genarate7DaysData(data.map(val => val.order_subtotal_sum))
                this.goods_count = data.goods_count
                this.goodsList = data.goods_data_list
                this.goods_stock_sum = data.goods_stock_sum
            }).catch(e => {
                openMessage("error", e.message)
            })
        },

        getbranchShopTradingData() {
            $fetch.post({
                url: '/chain/getbranchshoptradingdata',
                params: {
                    chain_shop_uid: this.shopId, // '74b42db82ef74da5ae78ac1bd15efe20'
                }
            }).then(data => {
                this.shop_count = data.branch_shop_count
                this.shopList = data.shop_goods_info_response
            }).catch(e => {
                openMessage("error", e.message)
            })
        },

        getShopInfo() {
            $fetch.post({
                url: '/chain/getchainshopbyuid',
                params: {
                    uid: this.shopId, // '74b42db82ef74da5ae78ac1bd15efe20'
                }
            }).then(data => {
                this.chain_shop = data.chain_shop
                // this.shop_count = data.branch_shop_count
                // this.shopList = data.shop_goods_info_response
            }).catch(e => {
                openMessage("error", e.message)
            })
        }
    },

    components: {
        // EnoAutoScroll
    }
}
</script>
<style lang="scss" scoped>
.data-screen {
    background-image: url("./images/bg.jpg");
    background-size: cover;
    padding: 0 30px 30px 30px;
}

.top {
    align-items: flex-end;
    // padding: 0 30px;
    padding-bottom: 6px;
    justify-content: space-between;

    .top-left {
        position: relative;
        flex: 1;
        max-width: 690px;
        // background-image: url("./images/top-left.svg");
        height: 50px;
        background-size: cover;
        background: url('./images/haderleft1.svg') no-repeat, url('./images/headerright1.svg') no-repeat;
        background-position: left center, right center;
    
        span {
            font-family: PingFangSC-Medium;
            font-size: 24px;
            color: #FFFFFF;
            letter-spacing: 7.69px;
            text-align: center;
            // text-shadow: 0 0 4px rgba(70,255,194,0.26);
            line-height: 60px;
        }

        .support {
            background-image: -webkit-linear-gradient(bottom, #a2ffe6, #22f7bf);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    .top-center {
        overflow: hidden;
        width: 480px;
        margin: 0 30px;
        height: 60px;
        background-image: url("./images/headerleft2.svg"), url("./images/top-center-item-1.svg"), url('./images/headerright2.svg');
        background-repeat: no-repeat;
        background-position: left center, center 0, right center;
        font-family: PingFangSC-Medium;
        font-size: 25px;
        color: #FFFFFF;
        letter-spacing: 7.69px;
        text-align: center;
        text-shadow: 0 0 4px rgba(70,255,194,0.26);
        line-height: 60px;
    }

    .top-right {
        flex: 1;
        max-width: 690px;
        // background-image: url("./images/top-right.svg");
        height: 50px;
        background-size: cover;
        background: url('./images/haderleft1.svg') no-repeat, url('./images/headerright1.svg') no-repeat;
        background-position: left center, right center;

        span {
            font-family: PingFangSC-Medium;
            font-size: 20px;
            color: #FFFFFF;
            text-shadow: 0 0 4px rgba(70,255,194,0.26);
        }
    }
}

.content {
    .left {
        width: 450px;

        .goods-data {
            padding: 20px;
            width: 210px;
            background-image: url("./images/goods-count-bg.svg");
            background-size: 100% 100%;

            .title {
                font-family: PingFangSC-Medium;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 21px;

                i {
                    margin-right: 10px;
                    height: 12px;
                    width: 2px;
                    background: #14CC9B;
                }
                
            }

            .amout {
                margin-top: 13px;
                margin-left: 12px;
                font-family: dataScreenNumber;
                font-size: 40px;
                color: #22FFC4;
            }
        }

        .stock-data {
            padding: 20px;
            width: 210px;
            background-image: url("./images/stock-bg.svg");
            background-size: 100% 100%;

            .title {
                font-family: PingFangSC-Medium;
                font-size: 15px;
                color: #FFFFFF;
                line-height: 21px;

                i {
                    margin-right: 10px;
                    height: 12px;
                    width: 2px;
                    background: #14CC9B;
                }
            }

            .amout {
                margin-top: 13px;
                margin-left: 12px;
                font-family: dataScreenNumber;
                font-size: 40px;
                color: #22FFC4;
            }
        }
        
        h2 {
            font-family: PingFangSC-Medium;
            font-size: 15px;
            color: #D4D4D4;
        }

        .goods-item {
            position: relative;
            margin-bottom: 20px;
            width: 450px;
            height: 62px;
            background: #0D120E;
            background-image: linear-gradient(144deg, #121914 0%, #030903 100%);
            border-radius: 12px;
            border: 1px solid rgb(16, 95, 72);

            &::after {
                content: "";
                position: absolute;
                right: 0;
                top: 50%;
                height: 11px;
                width: 2px;
                background: #14CC9B;
                transform: translateY(-50%);
            }

            img {
                margin-left: 6px;
                width: 50px;
                height: 50px;
                border-radius: 12px;
            }

            .goods-name {
                font-family: PingFangSC-Medium;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 28px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            .date {
                // margin-top: 4px;
                font-family: PingFangSC-Semibold;
                font-size: 12px;
                line-height: 17px;
                color: #D1D1D1;
            }

            .price {
                color: #fff;
                font-size: 20px;
                span {
                    &:nth-of-type(1) {
                        font-family: dataScreenNumber;
                        font-size: 20px;
                        color: #22FFC4;
                        line-height: 24px;
                    }

                    &:nth-of-type(2) {
                        font-family: PingFangSC-Semibold;
                        font-size: 12px;
                        color: #FFFFFF;
                        line-height: 17px;
                    }
                }
            }
        }
    }

    .video-container {
        height: 253px;
        background-image: url("./images/video-bg.svg");
    }

    .center-box {
        width: 100px;

        .order-content {
            width: 100%;
            height: 253px;
          
            // 今日交易额
            .total { // deal
                position: relative;
                height: 253px;
                // background-image: url("./images/deal.svg");
                background: url('./images/left1-1.svg') no-repeat,  url("./images/staircase.svg") no-repeat, url('./images/right-1-1.svg') no-repeat;
                background-position: left center, bottom right, right center;

                .money-1 {
                    position: absolute;
                    width: 97px;
                    height: 97px;
                    right: 38px;
                    top: 52px;
                    background-image: url("./images/money-1.svg");
                    background-size: 100%;
                    z-index: 1;

                }

                .decorator {
                    position: relative;
                    top: 0;
                    left: 50%;
                    margin-left: -40px;
                    width: 80px;
                    height: 7px;
                    // background-color: red;
                    background-image: url("./images/decorator.svg");

                }

                .rotate {
                    position: absolute;
                    width: 97px;
                    height: 97px;
                    right: 38px;
                    top: 52px;
                    background-image: url("./images/rotate-c.svg");
                    background-size: 100%;
                    z-index: 2;
                }


                .content {
                    position: relative;
                    z-index: 99;

                    .title {
                        margin-left: 30px;
                        margin-top: 50px;
                        font-family: PingFangSC-Medium;
                        font-size: 20px;
                        color: #FFFFFF;

                        > i {
                            margin-right: 12px;
                            display: inline-block;
                            width: 2px;
                            height: 16px;
                            // background: #D8D8D8;
                            background-image: linear-gradient(243deg, #00DFBB 0%, #14CC9B 95%);
                        }
                    }

                    .moeny {
                        margin-top: 10px;
                        margin-left: 35px;
                        font-family: dataScreenNumber;
                        font-size: 60px;
                        line-height: 70px;
                        color: #22FFC4;
                       
                    }

                    .yesterday {
                        margin-top: 16px;
                        margin-left: 43px;
                        font-family: dataScreenNumber;
                        font-size: 16px;
                        color: #14CC9B;
                    }
                }

            }

            .order {
                position: relative;
                height: 253px;
                // background-image: url("./images/deal.svg");
                background: url('./images/left1-1.svg') no-repeat, url("./images/staircase.svg") no-repeat,url('./images/right-1-1.svg') no-repeat;
                background-position: left center, bottom right, right center;
                backdrop-filter: brightness(70%);

                .order-1 {
                    position: absolute;
                    width: 97px;
                    height: 97px;
                    right: 38px;
                    top: 52px;
                    background-image: url("./images/order-1.svg");
                    background-size: 100%;
                }

                .decorator {
                    position: absolute;
                    top: 0;
                    left: 50%;
                    margin-left: -40px;
                    width: 80px;
                    height: 7px;
                    background-image: url("./images/decorator.svg");

                }

                .rotate {
                    position: absolute;
                    width: 97px;
                    height: 97px;
                    right: 38px;
                    top: 52px;
                    background-image: url("./images/rotate-c.svg");
                    background-size: 100%;
                    z-index: 2;
                }

                .content {
                    position: relative;
                    z-index: 99;

                    .title {
                        margin-left: 30px;
                        margin-top: 50px;
                        font-family: PingFangSC-Medium;
                        font-size: 20px;
                        color: #FFFFFF;

                        > i {
                            margin-right: 12px;
                            display: inline-block;
                            width: 2px;
                            height: 16px;
                            // background: #D8D8D8;
                            background-image: linear-gradient(243deg, #00DFBB 0%, #14CC9B 95%);
                        }
                    }

                    .moeny {
                        margin-top: 10px;
                        margin-left: 35px;
                        font-family: dataScreenNumber;
                        font-size: 60px;
                        color: #22FFC4;
                        line-height: 70px;
                       
                    }

                    .yesterday {
                        margin-top: 16px;
                        margin-left: 43px;
                        font-family: dataScreenNumber;
                        font-size: 16px;
                        color: #14CC9B;
                    }
                }

            }

        }

        .tiem-share-content {
            margin-top: 30px;
            position: relative;
            flex: 1;
            background: url('./images/timeleft.svg') no-repeat, url('./images//timeright.svg') no-repeat;
            background-position:  left center, right center;
            background-size: contain;
            backdrop-filter: brightness(70%);


            .decorator {
                position: absolute;
                top: 0;
                left: 50%;
                margin-left: -40px;
                width: 80px;
                height: 7px;
                background-image: url("./images/decorator.svg");

            }

            .title {
                position: absolute;
                width: 100%;
                padding-top: 20px;
                padding-left: 30px;
                padding-right: 30px;

                color: #fff;

                i.v-line {
                    margin-right: 10px;
                    display: inline-block;
                    width: 2px;
                    height: 18px;
                    // background: #D8D8D8;
                    background-image: linear-gradient(243deg, #00DFBB 0%, #14CC9B 95%);
                }

                i.h-line-1 {
                    display: inline-block;
                    width: 16px;
                    height: 1px;
                    // background: #D8D8D8;
                    background:#07FFBD;
                }

                i.h-line-2 {
                    display: inline-block;
                    width: 16px;
                    height: 1px;
                    // background: #D8D8D8;
                    background: rgb(23, 136, 103);
                }
            }
        }

        .recent-content {
            position: relative;
            margin-top: 30px;
            flex: 1;
            background: url('./images/timeleft.svg') no-repeat, url('./images//timeright.svg') no-repeat;
            background-position:  left center, right center;
            background-size: contain;
            backdrop-filter: brightness(70%);
            .decorator {
                position: absolute;
                top: 0;
                left: 50%;
                margin-left: -40px;
                width: 80px;
                height: 7px;
                background-image: url("./images/decorator.svg");

            }

            .title {
                position: absolute;
                width: 100%;
                padding-top: 20px;
                padding-left: 30px;
                padding-right: 30px;

                color: #fff;

                i.v-line {
                    margin-right: 10px;
                    display: inline-block;
                    width: 2px;
                    height: 18px;
                    // background: #D8D8D8;
                    background-image: linear-gradient(243deg, #00DFBB 0%, #14CC9B 95%);
                }
            }
        }   
    }

    .right {
        width: 450px;

        .shop-list {
            position: relative;
            // background-image: url("./images/shop-count.svg");
            // background-size: 100% 100%;
            background: url('./images/userleft.svg') no-repeat, url('./images/userright.svg') no-repeat;
            background-position: left center, right center;
            background-size: contain;
            backdrop-filter: brightness(70%);


            .decorator {
                position: absolute;
                top: 0;
                left: 50%;
                margin-left: -40px;
                width: 80px;
                height: 7px;
                background-image: url("./images/decorator.svg");

            }

            .shop-count-bg {
                position: absolute;
                height: 192px;
                width: 450px;
                top: 0;
                right:0;
                // right: 0;
                // bottom: 0;
                background-image: url("./images/shop-count-bg1.svg");
            }


            // 内容
            .top {
                p {
                    &:nth-of-type(1) {
                        margin-left: 30px;
                        margin-top: 30px;
                        font-family: PingFangSC-Medium;
                        font-size: 15px;
                        color: #FFFFFF;

                        > i {
                            margin-right: 10px;
                            display: inline-block;
                            width: 2px;
                            height: 12px;
                            background-image: linear-gradient(243deg, #00DFBB 0%, #14CC9B 95%);
                        }
                    }
                    &:nth-of-type(2) {
                        margin-top: 23px;
                        margin-bottom: 36px;
                        margin-left: 42px;
                        font-family: dataScreenNumber;
                        font-size: 40px;
                        color: #22FFC4;
                        line-height: 47px;
                    }
                    &:nth-of-type(3) {
                        margin-left: 30px;
                        font-family: PingFangSC-Medium;
                        font-size: 15px;
                        color: #D4D4D4;

                        > i {
                            margin-right: 10px;
                            display: inline-block;
                            width: 2px;
                            height: 12px;
                            background-image: linear-gradient(243deg, #00DFBB 0%, #14CC9B 95%);
                        }
                    }
                }
            }

            .center-1 {
                margin-top: 14px;
                padding: 0 30px;


                .item {
                    display: flex;
                    align-items: center;
                    border-bottom: 1px solid #455745;
                    // transform: scaleY(-1);
                    // background: #455745;
                    // border-radius: 6px;

                    height: 57px;
                    color: #fff;

                    .col-1 {
                        display: flex;
                        align-items: center;
                        width: 32px;
                        flex-shrink: 0;

                        > img {
                            display: inline-block;
                            width: 22px;
                            height: 22px;
                        }

                    }
                    .first {
                        color: #FFDE38;
                    }

                    .other {
                        color: #22FFC4;
                    }

                    .col-2 {
                        flex: 1;
                        font-family: PingFangSC-Medium;
                        font-size: 15px;
                        color: #FFFFFF;
                    }

                    .col-3 {
                        display: flex;
                        align-items: center;
                        // justify-content: center;
                        width: 120px;
                        flex-shrink: 0;
                        background: #262E29;

                        .grid-wrap {
                            display: flex;
                            align-items: center;
                            padding: 0 2px;
                            height: 16px;
                            background: #262E29;
                        }

                        .grid-item {
                            display: flex;
                            // height: 16px;
                            // background: #262E29;
                            // grid-template-columns: at(auto-fill, 12px);
                            // background:  linear-gradient( to right,#14CC9B, #F9EC1E);
                            

                            > div {
                                position: relative;
                                width: 12px;
                                height: 12px;
                                // background-color: red;
                                &::after {
                                    content: '';
                                    position: absolute;
                                    width: 1px;
                                    height: 12px;
                                    background-color: #030903;
                                    top: 0;
                                    right: 1;
                                }

                            }
                        }

                        .first {
                             background:  linear-gradient( to right,#FF821E , #F9EC1E);
                        }

                        .other {
                            background:  linear-gradient( to right,#14CC9B, #F9EC1E);
                        }
                    }

                    .col-4 {
                        font-family: dataScreenNumber;
                        width: 70px;
                        flex-shrink: 0;
                        text-align: right;
                    }
                }
            }
            
        }
    }
}
</style>